import React from 'react';
import { Input } from '../../../Components/Input';
import { Button } from '../../../Components/Button';
import { Text } from '../../../Components/Typography';
import { PrecioAnillado } from '../../../hooks/usePreciosAnillado';
import './AnilladoFilters.scss';

interface AnilladoFiltersProps {
  precios: PrecioAnillado[];
  filters: {
    selectedHojas: string[];
    searchTerm: string;
  };
  onFiltersChange: (filters: any) => void;
  onClearFilters: () => void;
}

export const AnilladoFilters: React.FC<AnilladoFiltersProps> = ({
  precios,
  filters,
  onFiltersChange,
  onClearFilters
}) => {
  // Extraer opciones únicas de los precios
  const uniqueHojas = Array.from(new Set(precios.map(p => p.hoja_name)));

  const handleHojaChange = (hoja: string, checked: boolean) => {
    const newHojas = checked 
      ? [...filters.selectedHojas, hoja]
      : filters.selectedHojas.filter(h => h !== hoja);
    
    onFiltersChange({
      ...filters,
      selectedHojas: newHojas
    });
  };

  const handleSearchChange = (value: string) => {
    onFiltersChange({
      ...filters,
      searchTerm: value
    });
  };

  const hasActiveFilters = () => {
    return filters.selectedHojas.length > 0 ||
           filters.searchTerm.trim() !== '';
  };

  return (
    <div className="anillado-filters">
      <div className="filters-header">
        <div className="header-left">
          <Text bold>🔍 Filtros</Text>
          {hasActiveFilters() && (
            <span className="active-count">
              ({filters.selectedHojas.length + (filters.searchTerm ? 1 : 0)})
            </span>
          )}
        </div>
        {hasActiveFilters() && (
          <Button onClick={onClearFilters} outlined small>
            🗑️ Limpiar
          </Button>
        )}
      </div>

      <div className="filters-content">
        {/* Búsqueda */}
        <div className="search-section">
          <Input
            placeholder="🔍 Buscar precios de anillado..."
            value={filters.searchTerm}
            onChange={handleSearchChange}
          />
        </div>

        {/* Filtros rápidos */}
        <div className="quick-filters">
          {/* Tamaño de Hoja */}
          <div className="filter-group">
            <div className="filter-label">
              <Text bold>Tamaño de Hoja</Text>
              <span className="count">({filters.selectedHojas.length}/{uniqueHojas.length})</span>
            </div>
            <div className="filter-options">
              {uniqueHojas.map(hoja => (
                <button
                  key={hoja}
                  className={`filter-option ${filters.selectedHojas.includes(hoja) ? 'active' : ''}`}
                  onClick={() => handleHojaChange(hoja, !filters.selectedHojas.includes(hoja))}
                >
                  {hoja}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
